import { render, staticRenderFns } from "./MicPermissionModal.vue?vue&type=template&id=3a1f309e&scoped=true"
import script from "./MicPermissionModal.vue?vue&type=script&lang=js"
export * from "./MicPermissionModal.vue?vue&type=script&lang=js"
import style0 from "./MicPermissionModal.vue?vue&type=style&index=0&id=3a1f309e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1f309e",
  null
  
)

export default component.exports